
    
  import React, { useReducer } from "react";
  import axios2 from 'services/axios2';

  import {useParams} from "react-router-dom";
  import {Link,hashHistory} from 'react-router-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import { NuDropdown } from "components/nubox/NuDropdown";

  import ImageUpload from "components/nubox/ImageUpload";
  import NuConfirm from "components/nubox/Box/NuConfirm";
  import { withRouterJim } from "router/withRouterJim";
  import ImageUploadSingle from 'components/nubox/ImageUploadSingle';

  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from "reactstrap";

  const cbo=[
    {  value:'1', label: 'label1'},
  ]
  
  let initialForm = {
    idd:0,
    ope:'n',  
    id_doc:'',
    nro_doc:'',
    nomape:'',
    tel:'',
    foto_path1:'',
    estado:'',
  };

  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class Docente extends React.Component {
    state = {

      modalImagen: false,
      
      form: Object.assign({}, initialForm),
      data: [],/* lista  */
      
    };
     //--------------------------------------
    constructor(props) {
      super(props);

      this.refNuConfirm = React.createRef();
    }
    //------------------
    //---------------------------------
    componentDidMount() {
      //--limpiamos el array de prueba
      this.setState({data:[]});
  
      // Get the userId param from the URL.
      let idd = this.props.params.idd;
      let ope = this.props.params.ope;
      
      console.log("idd-->" + idd);
      console.log("ope-->" + ope);
      this.setState({ form:{...this.state.form, idd: idd, ope:ope}}); 
      if(ope==='e' || ope==='x'){
        this.cargar_form(idd, ope);
      }
      
      //this.cargar_citas();
    }
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      
      //--- esto lo hacemos porque en vez de utilizar valores true, false
      //--- tenemos que utilizar 1, 0
      if(e.target.type==="checkbox"){

        let res = e.target.checked? 1:0;        
        this.setState({
          form:{
            ...this.state.form,
            [e.target.name]: res,
          }
        })
      }else{
        this.setState({
          form: {
            ...this.state.form,
            [e.target.name]: e.target.value,
          },
        });
      }
    };
    //-----------------------------------------
    cargar_form = (idd, ope) => {      
  
      let param = { 
        idd: idd,
        ope:'f'
      }
      console.log(param);
      axios2.post( "docente_store", param)
      .then(res => {
        
          if( res.data!==''){ 
              //añadimos el id y ope
              this.setState({
                form: {  ...res.data, 
                  idd: idd,  
                  ope: ope,
                },
              });
              
          }else{
            toast.error("Registro no encontrado", {
              position: toast.POSITION.TOP_RIGHT
            });
          }
  
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    };
    //-------------
    handleSubmit = event => {
      event.preventDefault();
      this.cargar_form();
    }
    /************************************************ */
    okImage = (filename) =>{    
      this.setState({ form:{...this.state.form, foto_path1: filename}}); 
    }
    cancelImage = () =>{
      //---ocultamos la ventana
      this.setState({ form:{...this.state.form, foto_path1: '' }}); 
    }
    //-----------------------------------------------
    aceptar_click = async () => {
      console.log("aceptar");
      this.save();
      
    }
    //----------------------------
    save =() =>{    
        let param =  this.state.form;
            
        axios2.post("docente_store", param)
        .then(res => {
            if(res.data.exito === 1){ 
                toast.success(res.data.mensaje);
                //--- tenemos que redireccionar
                this.props.navigate('/DocenteList');
            }else{
                toast.error(res.data.mensaje);
            }
    
        }).catch(error => {
            alert("---- Existio un error ---");
            console.log(error);
            
        });
      
    }
    //------------------------------
    render() {
      return (
        <div>
          <ToastContainer />
          <div className="content">

            {/* ---   --- */}
            <section className="content-header">
              <h3>
                {this.state.form.ope === 'n'
                  ? "Nuevo "
                  : "Editar "
                }
                docente
              </h3>
            </section>

            <section className="content">
              
                <div className="card">
                  
                  <div className="card-body">
                    {/*-----*/}
                                      
        <form  method='POST'>
        
            <div className='top_title2'>
              <h4 className=''>Bloque 0</h4>
            </div>
            
                <div className='form-group row'>
                    <label htmlFor='id_doc' className='col-lg-3 control-label'><b>id_doc</b></label>
                    <div className='col-lg-9'>
                        
        <input
          type='text'
          name='id_doc'
          value={this.state.form.id_doc}
          onChange={this.handleChangeForm}
          className='form-control'
          disabled
        />
      
                    </div>
                </div>
                <div className='form-group row'>
                    <label htmlFor='nro_doc' className='col-lg-3 control-label'><b>nro_doc</b></label>
                    <div className='col-lg-9'>
                        
        <input
          type='text'
          name='nro_doc'
          value={this.state.form.nro_doc}
          onChange={this.handleChangeForm}
          className='form-control'
        />
      
                    </div>
                </div>
                <div className='form-group row'>
                    <label htmlFor='nomape' className='col-lg-3 control-label'><b>nomape</b></label>
                    <div className='col-lg-9'>
                        
        <input
          type='text'
          name='nomape'
          value={this.state.form.nomape}
          onChange={this.handleChangeForm}
          className='form-control'
        />
      
                    </div>
                </div>
                <div className='form-group row'>
                    <label htmlFor='tel' className='col-lg-3 control-label'><b>tel</b></label>
                    <div className='col-lg-9'>
                        
        <input
          type='text'
          name='tel'
          value={this.state.form.tel}
          onChange={this.handleChangeForm}
          className='form-control'
        />
      
                    </div>
                </div>
                <div className='form-group row'>
                    <label htmlFor='foto_path1' className='col-lg-3 control-label'><b>foto_path1</b></label>
                    <div className='col-lg-9'>
                         
        <ImageUploadSingle  
          okImage={ this.okImage}
          cancelImage={ this.cancelImage}
          imageURL={process.env.REACT_APP_AFILES}
          fileName={this.state.form.foto_path1}
        />
        
                    </div>
                </div>
            <div className='top_title2'>
              <h4 className=''>Bloque 5</h4>
            </div>
            
                <div className='form-group row'>
                    <label htmlFor='estado' className='col-lg-3 control-label'><b>estado</b></label>
                    <div className='col-lg-9'>
                        
        <input
          type='text'
          name='estado'
          value={this.state.form.estado}
          onChange={this.handleChangeForm}
          className='form-control'
        />
      
                    </div>
                </div></form>
        
                  </div>

                  <div className="card-footer">
                      <div className="form-group">
                          <div className="text-center">
                            <Button onClick={ this.aceptar_click } className="btn btn-primary">
                              <i className="fa fa-floppy-o"></i>&nbsp;
                              Guardar 
                            </Button>
                            &nbsp;
                            <Link to='/DocenteList' className="btn btn-default">Volver</Link>
                          </div>
                      </div>
                  </div>
              
                </div>
    
            </section>
          </div>

          <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      );
    }
  }
    
  //------------para que soporte la funcionalidad de parametros
  export default withRouterJim(Docente);